import type { VoidFunctionComponent } from 'react';

import { icons, IconText } from '../../generic/Icon';

import styles from './ProjectPreview.module.less';

type Props = {
  deepestLevel: number;
};

/**
 * Header content displayed when the license scan has passed
 */
const HeaderContentPassing: VoidFunctionComponent<Props> = ({ deepestLevel }) => (
  <>
    <h2 className={`margin-top margin-top-responsive ${styles.headerTitlePassing}`}>
      <IconText icon={icons.review} text="License scan passed" />
    </h2>
    <span className={styles.headerSubtextPassing}>
      Last scanned <strong>4 hours ago</strong>
      <br />
      {deepestLevel > 0 ? `Found dependencies ${deepestLevel} levels deep` : ''}
    </span>
  </>
);

export default HeaderContentPassing;
